module.exports = __webpack_public_path__ + "img/room_number.bf78345b.svg";